const React = require('react')
const AdminButton = require('./admin_button')
const ViewerButton = require('./viewer_button')
const NavLink = require('./nav_link')
const { FreeComponent } = require('component/viewer/free')
const log = require('log').create('nav', 'viewer links') // eslint-disable-line

function GetStarted() {
    return (
        <NavLink
            href="/user/getstarted"
            className="getstarted"
            data-metric-channel="metrics_nav"
            data-metric-event="clicked:getstarted"
            >
            <strong>Get Started</strong>
        </NavLink>
    )
}

function ViewerLinks(props, context) {
    return (
        <ul className="userlinks">
            <GetStarted />
            <FreeComponent>
                <NavLink
                    href="/features"
                    className="features not-mobile"
                    data-metric-channel="metrics_nav"
                    data-metric-event="clicked:features"
                    >
                    Features
                </NavLink>
                <NavLink
                    href="/pricing"
                    className="pricing not-mobile"
                    data-metric-channel="metrics_nav"
                    data-metric-event="clicked:pricing"
                    >
                    Pricing
                </NavLink>
            </FreeComponent>
            <AdminButton className="not-mobile" />
            <ViewerButton />
        </ul>
    )
}

module.exports = ViewerLinks
